import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';

// ES6 class-style
class NrichCollaboration extends PreLoginSessionCheck {
  

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.swiper = null
  }

  goNext() {
    if (this.swiper) this.swiper.slideNext()
  }
 
  goPrev() {
    if (this.swiper) this.swiper.slidePrev()
  }

  openModal (someValue) {
    this.setState({isOpen: true})
    this.videoId = someValue
    console.log(this.videoId);
  }

  render() {
  	const videoId = '';
	const params = {
		slidesPerView: 1,
	 	spaceBetween: 30,
	 	loop: false,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    }
		}
    } 

  	return(
  	<section className="mtb collab-container">
        <h2>Our Academic Collaboration</h2>
		<div className="collab-row">
			<div className="container collab-bg">
            <div className="collab-content">                
                <img src="../img/nrich.png" alt="How HeyMath! really empowers Tutors and Teachers"/>
                <h3>HeyMath! and MMP/NRICH</h3>
                <p>HeyMath! was founded in the year 2000 in collaboration with the Millennium Mathematics Project (MMP) and NRICH(which is an integral part of MMP) at the University of Cambridge
                </p>
                <p>Experts from NRICH have been involved right from the inception of HeyMath! and have played an instrumental role in shaping the innovative pedagogies and high quality that underlies HeyMath’s digital program.
                </p>               
            </div>

            <div className="video-content">
				{/* <Swiper className="student-slider" slidesPerView={params.slidesPerView}  breakpoints={params.breakpoints} loop={params.loop} spaceBetween={params.spaceBetween} ref={node => {if(node) this.swiper = node.swiper} }> */}
					
					<div data-ga="Home - How HeyMath! really empowers Tutors and Teachers" className="swiper-slide">
						<div className="img-box popup-youtube single-video" onClick={this.openModal.bind(null,'2wmnGsAmwMw')}>
							<img src="../img/nrich_video_img.jpg" alt="How HeyMath! really empowers Tutors and Teachers"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
				{/* </Swiper> */}
                <span>What makes an effective Mathematics teacher?</span>
            </div>
				{/* <div className="slider-btns">
	        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
	        		<div className="swiper-button-next swp-next"  onClick={this.goNext}></div>
        		</div> */}
			</div> 
		</div>
		<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
	</section>
  	);
  }
}

export default NrichCollaboration;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/NrichCollaboration.js